import primaryComponents from "../../../primaryComponents";
import { useSmsSenderIdForm } from "./useSmsSenderIdForm";
import useValidation from "./useValidation";
import styles from "./styles.module.scss";

export const SmsSenderIdForm = ({ closeModal = () => {} }) => {
  const { isLoading, formData, setFormData, handleCreateID } =
    useSmsSenderIdForm({ closeModal });

  const {
    control,
    trigger,
    formState: { errors },
    handleSubmit,
  } = useValidation({ ...formData });

  return (
    <div>
      <primaryComponents.InputFieldV2
        control={control}
        name="sender_id"
        label="Sender ID"
        placeholder="Enter sender id"
        classNames="white"
        isRequired
        value={formData?.sender_id}
        onChange={({ target: { value } }) => {
          setFormData((prev) => ({ ...prev, sender_id: value }));
        }}
        errorMessage={errors.sender_id}
        onKeyUp={() => errors.sender_id !== undefined && trigger("sender_id")}
      />

      <p className="dark--text mb-2">GUIDELINES FOR SENDER ID CREATION:</p>
      <ol className={styles.senderRule}>
        <li>
          Should not be more than 11 characters (a space counts as a character)
        </li>
        <li>Sender IDs should not contain special characters (.-,%#$@ etc)</li>
        <li>Sender IDs should not begin with a number</li>
        <li>Personal names and a name alone are not allowed for sender IDs</li>
        <li>
          Generic IDS too like happy, warning, goodness are not acceptable, etc
        </li>
      </ol>

      <primaryComponents.Button
        classNames={"btn btn--primary w-100 mt-4"}
        type="button"
        isDisabled={isLoading}
        isLoading={isLoading}
        loadingText={"Processing..."}
        onClick={handleSubmit(handleCreateID)}
      >
        Create Sender ID
      </primaryComponents.Button>
    </div>
  );
};
